export default __webpack_public_path__ + "static/media/icon_isp_guide.2d3da4cb.svg";